import { render, staticRenderFns } from "./lsfzEcharts2.vue?vue&type=template&id=b5a5f3c2&scoped=true"
import script from "./lsfzEcharts2.vue?vue&type=script&lang=js"
export * from "./lsfzEcharts2.vue?vue&type=script&lang=js"
import style0 from "./lsfzEcharts2.vue?vue&type=style&index=0&id=b5a5f3c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a5f3c2",
  null
  
)

export default component.exports